import { CheckCircle2 } from "lucide-react";
import { useScrollReveal } from "@/hooks/useScrollReveal";

export default function WhyUs({ points }) {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section id="neden-biz" className="border-y border-white/5 bg-white/[0.015] py-24 md:py-32" data-testid="why-us-section">
      <div ref={ref} className={`reveal mx-auto max-w-7xl px-6 md:px-12 ${isVisible ? "is-visible" : ""}`}>
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-gold">Neden Biz</p>
          <h2 className="mt-3 text-2xl font-normal tracking-tight text-white sm:text-3xl lg:text-4xl">
            Sosyal medya reklam yönetiminde güvenilir çözüm ortağınız
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2">
          {points.map((point, i) => (
            <div
              key={i}
              className="flex items-start gap-4 rounded-2xl border border-white/5 bg-white/[0.02] p-6 backdrop-blur-xl"
              style={{ transitionDelay: isVisible ? `${i * 100}ms` : "0ms" }}
              data-testid={`why-us-point-${i}`}
            >
              <CheckCircle2 className="mt-0.5 h-6 w-6 shrink-0 text-gold-light" />
              <p className="text-base leading-relaxed text-slate-300">{point}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
